/** @jsxImportSource @emotion/react */

import { useMutation } from '@apollo/client'
import { FC, useCallback, useState } from 'react'
import { createVideo, createVideoVariables } from '__generatedTypes__/createVideo'
import { updateVideoCategory, updateVideoCategoryVariables } from '__generatedTypes__/updateVideoCategory'
import { CREATE_VIDEO, UPDATE_VIDEO_CATEGORY } from 'queries/video'
import { useHistory } from 'hooks/useHistory'
import { toast } from 'utils/toast'
import { IVideoCategoryProps, IVideoData } from '../types'
import withVideoCategoryCheck from '../withVideoCategoryCheck'
import * as commonClasses from '../commonStyles'
import VideoContentForm from './VideoContentForm'

const VideoResourceCreate: FC<IVideoCategoryProps> = ({ videoCategory, redirectToVideoDashboard }) => {
  const { populateHistoryWithUser } = useHistory()
  const [initialValues] = useState({ tags: [] })

  const [createVideo] = useMutation<createVideo, createVideoVariables>(CREATE_VIDEO)
  const [updateVideoCategory] = useMutation<updateVideoCategory, updateVideoCategoryVariables>(UPDATE_VIDEO_CATEGORY)

  const handleSubmit = useCallback(
    async (fieldsValues: IVideoData, videoLengthSec: number) => {
      try {
        const { data } = await createVideo({
          variables: {
            createVideoInput: {
              title: fieldsValues.title,
              link: fieldsValues.link,
              order: videoCategory.video.length,
              membershipLevel: fieldsValues.membershipLevel.id,
              videoLength: videoLengthSec,
              tags: fieldsValues.tags ?? [],
              history: populateHistoryWithUser(),
            },
          },
        })

        const videos = videoCategory.video?.map((video) => ({ id: video.id })) || []
        await updateVideoCategory({
          variables: {
            updateVideoCategoryInputFieldName: {
              id: videoCategory.id,
              video: [...videos, { id: data?.createVideo.id || '' }],
            },
          },
        })

        redirectToVideoDashboard()
        toast.success('Video created successfully')
      } catch (error) {
        toast.error('Failed to create video')
      }
    },
    [videoCategory, populateHistoryWithUser]
  )

  return (
    <div css={commonClasses.containerPadding}>
      <VideoContentForm videoCategory={videoCategory} handleSubmit={handleSubmit} initialValues={initialValues} />
    </div>
  )
}

export default withVideoCategoryCheck(VideoResourceCreate)
